var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parameter"},[_c('div',{staticClass:"conter",domProps:{"innerHTML":_vm._s(_vm.description)}}),(!_vm.description)?_c('Empty',{attrs:{"description":"暂无数据"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }